import React from "react";

// Small Bronze→Platinum creator reputation badge driven by plays/ratings/sales.
// Pass the `tier` object returned by the API ({label, color, emoji, next_label, next_plays, plays}).
export function CreatorTierBadge({ tier, size = "sm", showLabel = true }) {
  if (!tier) return null;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-1 text-xs";
  const title = tier.next_label
    ? `${tier.label} — ${Math.max(0, (tier.next_plays || 0) - (tier.plays || 0)).toLocaleString()} more plays to ${tier.next_label}`
    : tier.label;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-bold ${pad}`}
      style={{ background: `${tier.color}22`, color: tier.color, border: `1px solid ${tier.color}55` }}
      title={title}
      data-testid="creator-tier-badge"
    >
      <span>{tier.emoji}</span>{showLabel && <span>{tier.label}</span>}
    </span>
  );
}

export default CreatorTierBadge;
